import request from "@/utils/request";

export function reportList(data) {
  return request({
    url: "/consumer/report/list",
    method: "post",
    data
  });
}

export function etcInfo(id) {
  return request({
    url: `/consumer/report/electronicCertificate/info?id=${id}`,
    method: "get"
  });
}

export function etcList(data) {
  return request({
    url: "/consumer/report/electronicCertificate/list",
    method: "post",
    data
  });
}

export function etcSave(data) {
  return request({
    url: "/consumer/report/electronicCertificate/save",
    method: "post",
    data
  });
}

export function etcDiscard(id) {
  return request({
    url: `/consumer/report/electronicCertificate/discard?id=${id}`,
    method: "get"
  });
}

export function visitRecord(data) {
  return request({
    url: "/consumer/report/electronicCertificate/visitRecord",
    method: "post",
    data
  });
}

export function reportPreview(data) {
  return request({
    url: "/consumer/report/preview",
    method: "post",
    data
  });
}

export function reportDelete(data) {
  return request({
    url: "/consumer/report/reportDelete",
    method: "delete",
    data
  });
}
export function certificateDetail(id) {
  return request({
    url: `/consumer/report/electronicCertificate/info?id=${id}`,
    method: 'GET',
  })
}

export function waitDeal() {
  return request({
    url: "/consumer/inspectionRecord/inspectedPerson/waitDeal",
    method: "post",
  });
}
export function reportCreateDate(id) {
  return request({
    url: `/consumer/report/reportCreateDate?id=${id}`,
    method: 'GET',
  })
}


// WEBPACK FOOTER //
// ./src/api/report.js